import {
  HTTP_METHOD_GET,
  apiRequest,
  commonRequestInstanceToAxiosRequestInfo,
} from '@/common/api/api.service'
import { API_BASE_URL } from '@/common/constant'
import { stringify } from 'query-string'
import { normalizeEventList } from '@/common/normalize'

/**
 * 이벤트 목록을 조회한다.
 * @param status 이벤트 상태 [all, y(이벤트 중), n(이벤트 종료)]
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 */
export const getEventList = async ({ status, offset = 0, limit = 10 }) => {
  const queryParams = stringify({
    status,
    offset,
    limit,
  })
  const response = await apiRequest(
    commonRequestInstanceToAxiosRequestInfo({
      url: `${API_BASE_URL}/events?${queryParams}`,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true,
    }),
    (error) => {
      return { error: { ...error } }
    },
  )
  if (!response || response?.error) {
    return response
  }

  response.data = normalizeEventList(response?.data)
  return response
}
